import mermaid, { mermaidAPI } from 'mermaid';
import convertRough from '../convertRough';

mermaid.initialize({
  startOnLoad:true
});

const mermaidPromisifyRender = (name, input) =>
  new Promise(resolve => mermaidAPI.render(name, input, resolve));

let count = 0;
export default async (input, options = {}) => {
  // TODO: Use count to make each svg unique.
  const html = await mermaidPromisifyRender('mermaid' + count, input);
  count += 1;
  var svg = (new DOMParser()).parseFromString(html, 'image/svg+xml').firstChild;
  return convertRough(svg, options);
};
